define( function() {
	"use strict";

	return ( /^(?:checkbox|radio)$/i );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/rcheckableType.js
// module id = 110
// module chunks = 0